var ConfirmDeletionSheetEnum = /* @__PURE__ */ ((ConfirmDeletionSheetEnum2) => {
  ConfirmDeletionSheetEnum2["CONFIRM_DELETION_SHEET"] = "confirm-deletion-sheet";
  ConfirmDeletionSheetEnum2["CONFIRM_DELETION_SHEET_TITLE"] = "confirm-deletion-sheet--title";
  ConfirmDeletionSheetEnum2["CONFIRM_DELETION_SHEET_CLOSE_BUTTON"] = "confirm-deletion-sheet--close-button";
  ConfirmDeletionSheetEnum2["CONFIRM_DELETION_SHEET_MESSAGE"] = "confirm-deletion-sheet--message";
  ConfirmDeletionSheetEnum2["CONFIRM_DELETION_SHEET_PRIVACY_POLICY_LINK"] = "confirm-deletion-sheet--privacy-policy-link";
  ConfirmDeletionSheetEnum2["CONFIRM_DELETION_SHEET_CONFIRM_BUTTON"] = "confirm-deletion-sheet--confirm-button";
  ConfirmDeletionSheetEnum2["CONFIRM_DELETION_SHEET_CANCEL_BUTTON"] = "confirm-deletion-sheet--cancel-button";
  return ConfirmDeletionSheetEnum2;
})(ConfirmDeletionSheetEnum || {});
export {
  ConfirmDeletionSheetEnum
};
